var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.955 6a2.003 2.003 0 00-2.001 2.001V11h-1.999l2 12h1.007l1.993-12h-2.001V8.001a1 1 0 112.001 0V8.5a.5.5 0 001 0v-.499a2.003 2.003 0 00-2-2.001zm-2 19.5a.5.5 0 001 0V24h-1zm6.515-8.326a3.035 3.035 0 01.949-2.439c.503-.453.795-.655.795-1.198 0-.619-.506-1.022-1.339-1.022a2.867 2.867 0 00-1.78.58l-.216-.127v-1.387A3.854 3.854 0 0123.076 11c1.907 0 2.879.959 2.879 2.424a2.564 2.564 0 01-1.263 2.134 1.976 1.976 0 00-.733 1.616zm1.68.946V20h-1.87v-1.88zM9.982 11l-.504.706L8.973 11H6.914v1.967l-1.79 1.79a.728.728 0 101.02 1.038l.009-.008.76-.76-.003 4.805a.504.504 0 001.009 0v-2.778h.337V20.5a.504.504 0 001.008 0v-3.446h.337V20.5a.504.504 0 001.009 0v-3.446h.336V19.5a.504.504 0 001.01 0V11z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.955 3a13 13 0 11-13 13 13 13 0 0113-13m0-1a14 14 0 1014 14 14 14 0 00-14-14z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--lost-and-found-circle-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'LostAndFoundCircleIcon';
export default Icon;